// extracted by mini-css-extract-plugin
export default {"header":"Header_header__RGawZ","stickyHeader":"Header_stickyHeader__7DNxO","btnBrand":"Header_btnBrand__brtLj","closingBtn":"Header_closingBtn__BDFox"};